import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';

// Normalize: es-MX, es-ES, es-* → 'es'; everything else → 'en'
const lang = (navigator.language || 'es').toLowerCase();
const resolved = lang.startsWith('es') ? 'es' : 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: { es: { translation: es }, en: { translation: en } },
    lng: resolved,
    fallbackLng: 'es',
    interpolation: { escapeValue: false },
  });

export default i18n;
